/**
 * Single source of truth for the production site URL.
 *
 * Set VITE_SITE_URL in .env (dev) and .env.production (prod) to override.
 * Falls back to longshineboitech.com — the registered domain — when no env
 * is set. Trailing slash stripped so `${SITE_URL}/path` always renders
 * cleanly.
 *
 * Replaces the dozens of `"https://www.longshineboitech.com"` literals
 * that were scattered across SEO meta, JSON-LD, breadcrumbs, sitemap
 * helpers, and admin defaults.
 */
export const SITE_URL: string = (
  import.meta.env.VITE_SITE_URL ?? "https://www.longshineboitech.com"
).replace(/\/+$/, "");

/**
 * Build an absolute URL by joining a path to SITE_URL. Handles leading
 * slash safely (`/path` and `path` both work).
 */
export const absoluteUrl = (path: string): string => {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${p}`;
};
